import { render } from "./reports-head.vue?vue&type=template&id=31452471"
import script from "./reports-head.vue?vue&type=script&lang=js"
export * from "./reports-head.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__